import React, { useState, useEffect } from "react";
import "./ManageHologram.css";
import Axios from "axios";
import Table from "react-bootstrap/Table";

const ManageHologram = () => {
  const [data, setData] = useState([]);
  const [yearlyData, setYearlyData] = useState({});
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [allData, setAllData] = useState({
    totalQuantity: 0,
    totalUsed: 0,
    totalDamaged: 0,
  });

  useEffect(() => {
    Axios.get("https://nodei.ssccglpinnacle.com/getHologram").then(
      (response) => {
        const reversedData = response.data.reverse();
        setData(reversedData);
        const yearlyStats = {};
        reversedData.forEach((row) => {
          const rowDate = new Date(row.Date);
          const year =
            rowDate.getMonth() >= 3
              ? rowDate.getFullYear() + 1
              : rowDate.getFullYear();
          if (!yearlyStats[year]) {
            yearlyStats[year] = {
              totalQuantity: 0,
              totalUsed: 0,
              totalDamaged: 0,
            };
          }
          yearlyStats[year].totalQuantity += row.Quantity;
          yearlyStats[year].totalUsed += row.used ?? 0;
          yearlyStats[year].totalDamaged += row.damaged ?? 0;
        });
        setYearlyData(yearlyStats);
      }
    );
  }, []);

  useEffect(() => {
    const allYearsData = {
      totalQuantity: 0,
      totalUsed: 0,
      totalDamaged: 0,
    };

    for (const year in yearlyData) {
      allYearsData.totalQuantity += yearlyData[year].totalQuantity;
      allYearsData.totalUsed += yearlyData[year].totalUsed;
      allYearsData.totalDamaged += yearlyData[year].totalDamaged;
    }

    setAllData(allYearsData);
  }, [yearlyData]);

  const getYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    years.push(
      <option key="all" value="all">
        All
      </option>
    );

    const uniqueYears = new Set();
    for (let year in yearlyData) {
      uniqueYears.add(year);
    }
    uniqueYears.add((currentYear + 1).toString());
    uniqueYears.forEach((year) => {
      years.push(
        <option key={year} value={year}>
          FY-{parseInt(year) - 1}-{year}
        </option>
      );
    });
    return years;
  };

  const handleYearChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedYear(selectedValue === "all" ? "all" : parseInt(selectedValue));
  };

  return (
    <div className="managehologram">
      <h2 style={{ textAlign: "center" }}>Hologram Status</h2>
      <div>
        <label style={{ marginBottom: "2rem" }} htmlFor="yearSelector">
          Select Year:
          <select
            id="yearSelector"
            name="yearSelector"
            onChange={handleYearChange}
            value={selectedYear}
          >
            {getYearOptions()}
          </select>
        </label>
        <div>
          {selectedYear !== "all" && yearlyData[selectedYear] && (
            <>
              <p style={{ display: "inline-block", marginRight: "60px" }}>
                YTD dispatched by Pinnacle :{" "}
                <b>{yearlyData[selectedYear].totalQuantity}</b>
              </p>
              <p style={{ display: "inline-block", marginRight: "60px" }}>
                Used by Shivalik : <b>{yearlyData[selectedYear].totalUsed}</b>
              </p>
              <p style={{ display: "inline-block", marginRight: "30px" }}>
                Damaged/Destroyed/sent back:{" "}
                <b>{yearlyData[selectedYear].totalDamaged}</b>
              </p>
            </>
          )}

          {selectedYear === "all" && (
            <>
              <p style={{ display: "inline-block", marginRight: "30px" }}>
                YTD dispatched by Pinnacle: <b>{allData.totalQuantity}</b>
              </p>
              <p style={{ display: "inline-block", marginRight: "30px" }}>
                Used by Shivalik: <b>{allData.totalUsed}</b>
              </p>
              <p style={{ display: "inline-block", marginRight: "30px" }}>
                Damaged/Destroyed/sent back: <b>{allData.totalDamaged}</b>
              </p>
            </>
          )}
        </div>
      </div>
      <Table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          textAlign: "center",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                width: "16.6%",
                border: "1px solid #ddd",
                padding: "8px",
              }}
            >
              Dispatched Date
            </th>
            <th
              style={{
                width: "16.6%",
                border: "1px solid #ddd",
                padding: "8px",
              }}
            >
              Quantity
            </th>
            <th
              style={{
                width: "16.6%",
                border: "1px solid #ddd",
                padding: "8px",
              }}
            >
              Serial Number
            </th>
            <th
              style={{
                width: "16.6%",
                border: "1px solid #ddd",
                padding: "8px",
              }}
            >
              Used
            </th>
            <th
              style={{
                width: "16.6%",
                border: "1px solid #ddd",
                padding: "8px",
              }}
            >
              Damaged
            </th>
            <th
              style={{
                width: "16.6%",
                border: "1px solid #ddd",
                padding: "8px",
              }}
            >
              Vehicle Number
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.orderno}>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                {new Date(row.Date).toLocaleDateString("en-US", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                {row.Quantity}
              </td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                {row.StartingNo}-{row.EndingNo}
              </td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                {row.used ?? 0}
              </td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                {row.damaged ?? 0}
              </td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                {row.VehicleNo}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ManageHologram;
